import { Injectable } from '@angular/core';

@Injectable()
export class MockService {

// To test the code, set your clock to Thursday, September 13, 2018 9:15:00 PM
// to get the last session. Any time sooner than Thursday, September 13, 2018 8:25:00 PM
// will cause the display of sessions prior to the last one.
// Example
// Day 1 Session 1: xxx
// Day 1 Session 2: yyy
// Day 1 Session 3: zzz
  private raw = `
  {
    "error": {
      "code": 200,
      "message": "The process was successful"
    },
    "banner": "https://s3.us-west-2.amazonaws.com/files.highattendance.com/events/710/T0tRX8KvgX2018-06-29.jpg",
    "sessions": [
      {
        "id": 3093,
        "name": "External",
        "abstract": "N/A",
        "room": [
          {
            "id": 742,
            "name": "Room 1",
            "floor": "N/A",
            "number": "Room 1",
            "capacity": "N/A"
          }
        ],
        "url": "http://cybertesting.byethost32.com/agenda/index.html?i=1",
        "start_timestamp": 1536847200000,
        "end_timestamp":   1536849000000
      },
      {
        "id": 3094,
        "name": "Dell",
        "abstract": "N/A",
        "room": [
          {
            "id": 742,
            "name": "Room 1",
            "floor": "N/A",
            "number": "Room 1",
            "capacity": "N/A"
          }
        ],
        "url": "https://www.delltechnologies.com/en-us/events/forum/dallas/agenda.htm",
        "start_timestamp": 1536855300000,
        "end_timestamp":   1536856200000
      },
      {
        "id": 3095,
        "name": "Registration",
        "abstract": "N/A",
        "room": [
          {
            "id": 753,
            "name": "Level 1",
            "floor": "1",
            "number": "Level 1",
            "capacity": "2184"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [],
        "contents": [
          {
            "id": 6285,
            "name": "Dell Technologies / Make it real",
            "type": "website",
            "date_created_timestamp": 1528888343,
            "date_updated_timestamp": 1534947658,
            "thumbnail_file": "https://s3.us-west-2.amazonaws.com/files.highattendance.com/contents/company98/6285/thumbnails/small/FyKhR26QlNiZj5Gabr90.jpg",
            "url": "https://www.arrowecs.co.uk/blog/posts/2018/june/dell-technologies-world-make-it-real/"
          }
        ],
        "start_timestamp": 1536843600000,
        "end_timestamp": 1536847200000
      },
      {
        "id": 3096,
        "name": "Welcome and Executive Keynote",
        "abstract": "N/A",
        "room": [
          {
            "id": 752,
            "name": "Grand Ballroom",
            "floor": "4",
            "number": "Grand Ballroom",
            "capacity": "2000"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2005,
            "name": "John Roese",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": ""
          }
        ],
        "contents": [
          {
            "id": 6285,
            "name": "Dell Technologies / Make it real",
            "type": "website",
            "date_created_timestamp": 1528888343,
            "date_updated_timestamp": 1534947658,
            "thumbnail_file": "https://s3.us-west-2.amazonaws.com/files.highattendance.com/contents/company98/6285/thumbnails/small/FyKhR26QlNiZj5Gabr90.jpg",
            "url": "https://www.arrowecs.co.uk/blog/posts/2018/june/dell-technologies-world-make-it-real/"
          }
        ],
        "start_timestamp": 1536847200000,
        "end_timestamp": 1536850800000
      },
      {
        "id": 3098,
        "name": "Building the Connected Business powered by Dell Boomi",
        "abstract": "We live in a multi-cloud world. Dell Boomi can quickly and easily connect your applications and data so legacy on premise apps can interact with new Software as a Service Platforms, making your hybrid cloud solution a reality. Dell Boomi enhances and extends the Dell Technologies Digital and IT Transformation solutions by liberating your data to be consumed by cloud native apps in new and different way, whether the data/app lives on- or off-premise.",
        "room": [
          {
            "id": 743,
            "name": "Jr Ballroom - B1 & B2",
            "floor": "3",
            "number": "Jr Ballroom - B1 & B2",
            "capacity": "192"
          }
        ],
        "track": {
          "id": 551,
          "name": "Digital Transformation",
          "title": "Digital Transformation",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2007,
            "name": "Ben Schreiner",
            "email": "Ben_Schreiner@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Director, Business Development - Sales, SW-Boomi",
            "company": "Jessica Gomez - Boomi"
          }
        ],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3099,
        "name": "The Dell Technologies Multi-Cloud Strategy: On Prem, Off Prem or Public or Private. How do you choose?",
        "abstract": "Public, private, on premises, off premises. Do one or all of these provide what you need? Dell Technologies can help solve the challenges of Multi-Cloud and what it can mean for your business. This session will help you decipher what Cloud really can mean for you.",
        "room": [
          {
            "id": 743,
            "name": "Jr Ballroom - B1 & B2",
            "floor": "3",
            "number": "Jr Ballroom - B1 & B2",
            "capacity": "192"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2008,
            "name": "Garland Payne",
            "email": "Garland.Payne@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Advisory Systems Engineer",
            "company": "Dell EMC, Cloud Strategy"
          }
        ],
        "contents": [
          {
            "id": 6285,
            "name": "Dell Technologies / Make it real",
            "type": "website",
            "date_created_timestamp": 1528888343,
            "date_updated_timestamp": 1534947658,
            "thumbnail_file": "https://s3.us-west-2.amazonaws.com/files.highattendance.com/contents/company98/6285/thumbnails/small/FyKhR26QlNiZj5Gabr90.jpg",
            "url": "https://www.arrowecs.co.uk/blog/posts/2018/june/dell-technologies-world-make-it-real/"
          }
        ],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3100,
        "name": "The Power of Connectivity: The Dell EMC Networking Portfolio",
        "abstract": "Ethernet, Fiber Channel or Software Defined Networking, which is the right choice for you? This session will present the various Dell EMC Networking options and provide you will a complete overview of our networking offerings.",
        "room": [
          {
            "id": 745,
            "name": "Jr Ballroom - D2",
            "floor": "3",
            "number": "Jr Ballroom - D2",
            "capacity": "84"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [
          {
            "id": 2029,
            "name": "Michael Shannon",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": ""
          }
        ],
        "contents": [
          {
            "id": 6285,
            "name": "Dell Technologies / Make it real",
            "type": "website",
            "date_created_timestamp": 1528888343,
            "date_updated_timestamp": 1534947658,
            "thumbnail_file": "https://s3.us-west-2.amazonaws.com/files.highattendance.com/contents/company98/6285/thumbnails/small/FyKhR26QlNiZj5Gabr90.jpg",
            "url": "https://www.arrowecs.co.uk/blog/posts/2018/june/dell-technologies-world-make-it-real/"
          }
        ],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3101,
        "name": "Right-size technology for the modern workforce",
        "abstract": "When it comes to work technology, one size no longer fits all. Dell has invested in research to better understand how people really work and identified different types of workers (we call them personas) and the technology they need to be most productive. Whether they are in the office, at home, on the road or in the field, giving your employees the right technology for their job supports productivity, improves satisfaction, and maintains your return on investment.",
        "room": [
          {
            "id": 746,
            "name": "Meeting Room 4",
            "floor": "1",
            "number": "Meeting Room 4",
            "capacity": "88"
          }
        ],
        "track": {
          "id": 553,
          "name": "Workforce Transformation",
          "title": "Workforce Transformation",
          "description": "N/A",
          "color": "#00447C"
        },
        "speaker": [
          {
            "id": 2010,
            "name": "Ed Orlin",
            "email": "Ed_Orlin@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Director, Field Marketing",
            "company": "Dell, Tjay Cook"
          }
        ],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3103,
        "name": "Transforming the Future of Higher Ed",
        "abstract": "With the advancements that blockchain, AI and other transformative technologies are enabling in today’s IT environment, the possibilities for aiding Higher Education to transform processes and systems into higher levels of functionality, integration, and informative analytics to increase Student Success measures is rapidly expanding. Learn more about how these technologies can help transform your institution into the future!",
        "room": [
          {
            "id": 749,
            "name": "Meeting Room 7",
            "floor": "1",
            "number": "Meeting Room 7",
            "capacity": "119"
          }
        ],
        "track": {
          "id": 555,
          "name": "Higher Education",
          "title": "Higher Education",
          "description": "N/A",
          "color": "#43E2FA"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3104,
        "name": "Vigilance is the Word of the Day in Government Cybersecurity",
        "abstract": "Understand the cybersecurity trends and what steps governments can take to safeguard and protect assets and citizens.",
        "room": [
          {
            "id": 750,
            "name": "Meeting Room 8",
            "floor": "1",
            "number": "Meeting Room 8",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 556,
          "name": "State and Local Government",
          "title": "State and Local Government ",
          "description": "N/A",
          "color": "#B7295A"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3105,
        "name": "Emerging technology opportunities in Healthcare",
        "abstract": "Across the value chain, the bias in the business of healthcare today is to move towards action - to make streamlined care delivery real while demonstrating meaningful progress. There are also emerging technology platforms and solutions to support cross-industry consolidations while supporting game changing new business affiliations.  Along the way, we’ve seen disruptive startups and industry outsiders who are demonstrating their ability to ignite innovation to challenge the status quo. Gain further understanding of healthcare specific technology and solutions help leap your organization ahead – to become a digital leader as the industry transforms.",
        "room": [
          {
            "id": 751,
            "name": "Meeting Room 9",
            "floor": "1",
            "number": "Meeting Room 9",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 581,
          "name": "Healthcare",
          "title": "Healthcare",
          "description": "N/A",
          "color": "#6EA204"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3106,
        "name": "Building a Foundation for a Digital Business",
        "abstract": "The journey of transformation is unique to every organization but complex for all. VMware streamlines the journey to digital business by unlocking value from today’s technologies while enabling the integration of tomorrow’s. Join us to hear more about how VMware compute, cloud, mobility, networking, and security software forms a dynamic, consistent digital foundation to deliver the apps that power business innovation.",
        "room": [
          {
            "id": 742,
            "name": "Jr Ballroom - A1 & A2",
            "floor": "3",
            "number": "Jr Ballroom - A1 & A2",
            "capacity": "246"
          }
        ],
        "track": {
          "id": 557,
          "name": "VMware",
          "title": "VMware",
          "description": "N/A",
          "color": "#42AEAF"
        },
        "speaker": [
          {
            "id": 2031,
            "name": "Muneyb Minhazuddin",
            "email": "muneyb@vmware.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "VMware"
          }
        ],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3108,
        "name": "Workforce Transformation",
        "abstract": "As technology transforms the world, it is also transforming the way we work. Work is no longer a destination, it’s an activity. Workers want the choice to stay connected and be productive where, when and however they need. They also have a stronger point of view on technology. To successfully navigate this workforce transformation, you need to consider both end user needs and IT needs. Upgrading your hardware solves half the issue. Organizations also have to look at upgrading how they manage, support and secure their PCs, and find more efficient, effective solutions to meet the needs of this emerging workforce. In this session, let us explain how Workforce Transformation can work for you.",
        "room": [
          {
            "id": 744,
            "name": "Jr Ballroom - C2",
            "floor": "3",
            "number": "Jr Ballroom - C2",
            "capacity": "96"
          }
        ],
        "track": {
          "id": 558,
          "name": "Workforce Transformation Overview",
          "title": "Workforce Transformation Overview",
          "description": "",
          "color": "##00447C"
        },
        "speaker": [
          {
            "id": 2010,
            "name": "Ed Orlin",
            "email": "Ed_Orlin@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Director, Field Marketing",
            "company": "Dell, Tjay Cook"
          }
        ],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3109,
        "name": "Digital transformation is creating new challenges for security. Are you ready?",
        "abstract": "Business leaders across industries are focused on leveraging technology to reach the right customers quickly and to identify new opportunities. The IT transformation necessary to meet these goals has big implications on security. An understanding of strategy and tactics for a holistic view of your environment and an insight into the 'why' and 'how' of infrastructure security gives you the edge as chart your organization's transformation success.",
        "room": [
          {
            "id": 745,
            "name": "Jr Ballroom - D2",
            "floor": "3",
            "number": "Jr Ballroom - D2",
            "capacity": "84"
          }
        ],
        "track": {
          "id": 554,
          "name": "Security Transformation",
          "title": "Security Transformation",
          "description": "N/A",
          "color": "#CE1126"
        },
        "speaker": [
          {
            "id": 2033,
            "name": "Peter Beardmore",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Lori Kane - RSA"
          }
        ],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3110,
        "name": "Reduce Costs and Optimize Your Portfolio by Moving Apps to the Most Effective Platform",
        "abstract": "Did you know it's possible to save at least 20% of your current application budget? We will show how easy it can be to assess an application portfolio and determine cost saving areas by retiring unused apps and re-platforming or migrating others to more cost-effective cloud platforms. These platforms include private/public clouds, Pivotal Cloud Foundry, Virtustream, Azure, and others.",
        "room": [
          {
            "id": 746,
            "name": "Meeting Room 4",
            "floor": "1",
            "number": "Meeting Room 4",
            "capacity": "88"
          }
        ],
        "track": {
          "id": 551,
          "name": "Digital Transformation",
          "title": "Digital Transformation",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2034,
            "name": "Jeffrey Kelly",
            "email": "jkelly@pivotal.io",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Ellen Hughes"
          }
        ],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3111,
        "name": "The Power of Convergence: The Dell EMC Converged and Hyper Converged Portfolio",
        "abstract": "Converged and Hyper-Converged systems are the fastest way to achieve business outcomes. In this session, you will learn about how Dell EMC’s converged and hyper-converged portfolio, including VxRail, VxRack and VxBlock 1000, has evolved to support the requirements of modern data centers around the world.",
        "room": [
          {
            "id": 747,
            "name": "Meeting Room 5",
            "floor": "1",
            "number": "Meeting Room 5",
            "capacity": "97"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3112,
        "name": "Making Digital Campuses Real",
        "abstract": "As our daily lives are impacted more and more by digital technologies and data driven insights; expectations for what a smart, engaging, and effective campus is, are changing. Join us in exploring a range of what campuses are doing to build digitally enabled & intelligent campuses and a high level view of the modular platforms and tools they are using to make tomorrow's digital campus real today.",
        "room": [
          {
            "id": 749,
            "name": "Meeting Room 7",
            "floor": "1",
            "number": "Meeting Room 7",
            "capacity": "119"
          }
        ],
        "track": {
          "id": 555,
          "name": "Higher Education",
          "title": "Higher Education",
          "description": "N/A",
          "color": "#43E2FA"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3113,
        "name": "Leveraging Cloud and Modern Application Development to Transform Government",
        "abstract": "Explore examples where sustainable development practices are combined with scalable government IT infrastructure to modernize government and fundamentally change the way citizens are served.",
        "room": [
          {
            "id": 750,
            "name": "Meeting Room 8",
            "floor": "1",
            "number": "Meeting Room 8",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 556,
          "name": "State and Local Government",
          "title": "State and Local Government ",
          "description": "N/A",
          "color": "#B7295A"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3114,
        "name": "Health IT Transformation",
        "abstract": "Today, every healthcare organization is examining how to best apply rapidly emerging digital technologies to improve care, reduce risks, and cut costs. To accelerate this focus, organizations must effectively maximize health IT (HIT) value through the use of modernized technology, automated processes, and streamlined IT operations to accelerate innovation. Learn about the power of multi-cloud solutions, converged and hyper-converged strategies, and optimized and cloud native clinical applications to move your journey forward.",
        "room": [
          {
            "id": 751,
            "name": "Meeting Room 9",
            "floor": "1",
            "number": "Meeting Room 9",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 581,
          "name": "Healthcare",
          "title": "Healthcare",
          "description": "N/A",
          "color": "#6EA204"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3115,
        "name": "Lunch",
        "abstract": "N/A",
        "room": [
          {
            "id": 752,
            "name": "Grand Ballroom",
            "floor": "4",
            "number": "Grand Ballroom",
            "capacity": "2000"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536857100000,
        "end_timestamp": 1536861600000
      },
      {
        "id": 3116,
        "name": "Digital Transformation Overview",
        "abstract": "It's said that 'speed to market' is the only remaining competitive advantage. But it's not just about going fast. It's about building the right things for your customers. Pivotal offers the platform, tools, and methodologies that help the world's most important companies deliver exceptional user experiences. Join us to hear all about what it takes to transform how you build, deploy and run software.",
        "room": [
          {
            "id": 742,
            "name": "Jr Ballroom - A1 & A2",
            "floor": "3",
            "number": "Jr Ballroom - A1 & A2",
            "capacity": "246"
          }
        ],
        "track": {
          "id": 559,
          "name": "Pivotal",
          "title": "Pivotal",
          "description": "N/A",
          "color": "##42AEAF"
        },
        "speaker": [
          {
            "id": 2035,
            "name": "Sharad Gupta",
            "email": "shgupta@pivotal.io",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Pivotal"
          }
        ],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3117,
        "name": "Virtustream Cloud Services for Mission Critical Applications",
        "abstract": "Enterprises are under pressure to become more agile and innovative.  Virtustream helps enterprises transform mission critical applications to bring improved agility, performance, and security to core business applications.  Learn about how Virtustream helps enterprises modernize mission critical applications, accelerate cloud native enterprise application development, and solve cloud storage challenges to support digital and IT transformation.",
        "room": [
          {
            "id": 743,
            "name": "Jr Ballroom - B1 & B2",
            "floor": "3",
            "number": "Jr Ballroom - B1 & B2",
            "capacity": "192"
          }
        ],
        "track": {
          "id": 560,
          "name": "Virtustream",
          "title": "Virtustream",
          "description": "N/A",
          "color": "#42AEAF"
        },
        "speaker": [
          {
            "id": 2036,
            "name": "Paul Gray",
            "email": "Paul.Gray2@virtustream.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Roxanne Cartwright"
          }
        ],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3118,
        "name": "Dell EMC Storage: What’s New in PowerMax & XtremIO X2",
        "abstract": "Come learn all about what’s new in Dell EMC High-End Storage. The new Dell EMC PowerMax, the world's fastest array, is the most recent addition to our industry-leading portfolio. PowerMax is built on the core proven enterprise features of VMAX while also delivering unprecedented performance via NVMe technology and automated data placement for maximum performance with a built-in machine learning engine. The session will also cover XtremIO X2, the purpose-built All-Flash array with a metadata-centric architecture, continuing to deliver more performance, capacity, data services and simplicity. XtremIO’s unique metadata-aware native replication will be a cornerstone for this session.",
        "room": [
          {
            "id": 744,
            "name": "Jr Ballroom - C2",
            "floor": "3",
            "number": "Jr Ballroom - C2",
            "capacity": "96"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3119,
        "name": "Nvidia",
        "abstract": "N/A",
        "room": [
          {
            "id": 745,
            "name": "Jr Ballroom - D2",
            "floor": "3",
            "number": "Jr Ballroom - D2",
            "capacity": "84"
          }
        ],
        "track": {
          "id": 582,
          "name": "Nvidia",
          "title": "Nvidia",
          "description": "",
          "color": "#42AEAF"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3121,
        "name": "WWT",
        "abstract": "N/A",
        "room": [
          {
            "id": 747,
            "name": "Meeting Room 5",
            "floor": "1",
            "number": "Meeting Room 5",
            "capacity": "97"
          }
        ],
        "track": {
          "id": 583,
          "name": "WWT",
          "title": "WWT",
          "description": "N/A",
          "color": "##42AEAF"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3122,
        "name": "Enabling collaboration – the smart way. Protect student and administrative data while fostering academic freedom within higher education.",
        "abstract": "As security breaches become more prevalent, educational institutions are realizing that compliance isn’t enough to be secure. While your organization deals with the increasing demands of students, administrators, faculty, and staff - who wish to access resources anytime and anywhere - a key component of your security strategy must involve protecting data wherever it goes. Dell Data Security delivers a robust endpoint security solution that addresses the two critical pain points that continues to afflict Higher Ed security.",
        "room": [
          {
            "id": 749,
            "name": "Meeting Room 7",
            "floor": "1",
            "number": "Meeting Room 7",
            "capacity": "119"
          }
        ],
        "track": {
          "id": 555,
          "name": "Higher Education",
          "title": "Higher Education",
          "description": "N/A",
          "color": "#43E2FA"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3123,
        "name": "Emerging Technologies in Public Sector",
        "abstract": "How will the Government workforce need to change as a result of emerging technologies like AR/VR, Machine Learning, IoT and more?",
        "room": [
          {
            "id": 750,
            "name": "Meeting Room 8",
            "floor": "1",
            "number": "Meeting Room 8",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 556,
          "name": "State and Local Government",
          "title": "State and Local Government ",
          "description": "N/A",
          "color": "#B7295A"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3124,
        "name": "Precision Medicine Transformation",
        "abstract": "Precision medicine takes into account each patient’s variability in genes, environment and lifestyle.  This approach enables new and sometime personalized protocols for prevention, diagnosis, and treatment of disease. Use of precision medicine technologies and techniques is becoming a reality in distinct disciplines in healthcare, most notably in oncology and in treating certain chronic conditions. Delve into innovative analytics platforms that help create actionable insights from genomics, medical images and population health data.",
        "room": [
          {
            "id": 751,
            "name": "Meeting Room 9",
            "floor": "1",
            "number": "Meeting Room 9",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 581,
          "name": "Healthcare",
          "title": "Healthcare",
          "description": "N/A",
          "color": "#6EA204"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      },
      {
        "id": 3125,
        "name": "Migrating to Win10? How you can deploy new PC technology with greater speed and less effort",
        "abstract": "Migrating to Win10 promises improved performance and increased user productivity. But deploying PCs that take advantage of this powerful technology can be time consuming with tasks such as imaging, migration of user data, installation at multiple sites and, for remote users, securing the intellectual property that resides on PCs that have reached end of life. Learn how we can help you conquer the complexity of PC deployment and quickly realize the return on your investment.",
        "room": [
          {
            "id": 742,
            "name": "Jr Ballroom - A1 & A2",
            "floor": "3",
            "number": "Jr Ballroom - A1 & A2",
            "capacity": "246"
          }
        ],
        "track": {
          "id": 553,
          "name": "Workforce Transformation",
          "title": "Workforce Transformation",
          "description": "N/A",
          "color": "#00447C"
        },
        "speaker": [
          {
            "id": 2013,
            "name": "Martin Travis",
            "email": "Travis_L_Martin@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Dell, Megan Annen"
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3126,
        "name": "Cyber-Protection & Recovery – Protecting Your Business From a Destructive Cyber-Attack",
        "abstract": "According to analysts, 2-3 million Ransomware attacks occurred in 2016, predicted to double every year through 2019. However, most organizations’ backup infrastructure was not designed to recover from a cyberattack. Dell EMC and RSA can provide a resilient infrastructure to protect and recover from a destructive cyberattack. This session will include demonstrations of automated workflows and security analytics tools.",
        "room": [
          {
            "id": 743,
            "name": "Jr Ballroom - B1 & B2",
            "floor": "3",
            "number": "Jr Ballroom - B1 & B2",
            "capacity": "192"
          }
        ],
        "track": {
          "id": 554,
          "name": "Security Transformation",
          "title": "Security Transformation",
          "description": "N/A",
          "color": "#CE1126"
        },
        "speaker": [
          {
            "id": 2038,
            "name": "Ben Smith",
            "email": "ben.smit@rsa.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Field CTO",
            "company": "Lori Kane - RSA"
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3127,
        "name": "Dell IT’s Journey: Empowering our Digital Workforce",
        "abstract": "Today’s workplace is dynamic and flexible, and where we choose to do our work has extended far beyond the office setting, with mobile technology allowing us to do our work from practically anywhere anytime. Dell IT understands the evolving needs of our global workforce to be always on and always connected. We are putting the right devices in people’s hands, laps or offices empowering our workforce to perform at its best. Discover how Dell IT is delivering digital workplace solutions in a one size doesn’t fit all approach.",
        "room": [
          {
            "id": 744,
            "name": "Jr Ballroom - C2",
            "floor": "3",
            "number": "Jr Ballroom - C2",
            "capacity": "96"
          }
        ],
        "track": {
          "id": 553,
          "name": "Workforce Transformation",
          "title": "Workforce Transformation",
          "description": "N/A",
          "color": "#00447C"
        },
        "speaker": [
          {
            "id": 2039,
            "name": "Ajaz Munsiff",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Ajaz Munsiff/SMEs"
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3128,
        "name": "Iron Mountain",
        "abstract": "N/A",
        "room": [
          {
            "id": 746,
            "name": "Meeting Room 4",
            "floor": "1",
            "number": "Meeting Room 4",
            "capacity": "88"
          }
        ],
        "track": {
          "id": 611,
          "name": "Iron Mountain",
          "title": "Iron Mountain",
          "description": "Iron Mountain",
          "color": "#42AEAF"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3129,
        "name": "The Power of the Compute Portfolio: Dell EMC PowerEdge",
        "abstract": "Transforming IT can speed application deployment, reduce your effort on IT operations, and reduce costs.  PowerEdge is the bedrock of modern IT. Learn how our customers are using PowerEdge to power their applications now and in the future.",
        "room": [
          {
            "id": 746,
            "name": "Meeting Room 4",
            "floor": "1",
            "number": "Meeting Room 4",
            "capacity": "88"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [
          {
            "id": 2014,
            "name": "Gerard Svartz",
            "email": "Gerard_Svartz@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Field Marketing",
            "company": "Dell EMC"
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3131,
        "name": "Dell EMC: Harness the intersection of applications, data, and analytics for IoT",
        "abstract": "The proliferation of IoT devices has generated massive amounts of streaming data, which can overwhelm traditional storage platforms. This session will discuss how Dell EMC's Isilon and ECS platforms are optimized to store and analyze your company's IoT data, allowing you to capture insights that provide your business with a competitive advantage.",
        "room": [
          {
            "id": 747,
            "name": "Meeting Room 5",
            "floor": "1",
            "number": "Meeting Room 5",
            "capacity": "97"
          }
        ],
        "track": {
          "id": 551,
          "name": "Digital Transformation",
          "title": "Digital Transformation",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2041,
            "name": "David Hulme",
            "email": "David.Hulme@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Systems Engineering",
            "company": "Dell EMC, IoT"
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3132,
        "name": "Higher Education: Innovations in Immersive Learning",
        "abstract": "Today’s employers are requiring graduates who have been trained to research, problem solve and collaborate. Learn about innovative AR/VR and immersive learning technologies being implemented at institutions across the country that are preparing students for today’s workplace.",
        "room": [
          {
            "id": 749,
            "name": "Meeting Room 7",
            "floor": "1",
            "number": "Meeting Room 7",
            "capacity": "119"
          }
        ],
        "track": {
          "id": 555,
          "name": "Higher Education",
          "title": "Higher Education",
          "description": "N/A",
          "color": "#43E2FA"
        },
        "speaker": [
          {
            "id": 2027,
            "name": "Greg Chamitoff",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Professor, Aerospace Engineering and Director of the ASTRO Lab (and former Astronaut!)",
            "company": "Texas A&M"
          },
          {
            "id": 2028,
            "name": "Dr. Ann McNamara",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Associate Professor, Associate Dept Head, Graduate Program Coordinator, Dept of Visualization",
            "company": ""
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3133,
        "name": "Public Safety in 2020: Will you be ready?",
        "abstract": "Join industry experts for a lively discussion about how to deploy ruggedize devices, video surveillance, IoT, & FirstNet, while also preparing for NextGen 911 and 5G.",
        "room": [
          {
            "id": 750,
            "name": "Meeting Room 8",
            "floor": "1",
            "number": "Meeting Room 8",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 556,
          "name": "State and Local Government",
          "title": "State and Local Government ",
          "description": "N/A",
          "color": "#B7295A"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3134,
        "name": "Connected Health Transformation",
        "abstract": "Connected Health—a web of intelligent communication and actionable information sharing with the intention of improving patient outcomes (medical, social, financial, and environmental overall wellbeing)—is transforming the way healthcare is delivered. A fabric of underlying technology brings together people, processes, and devices that enable a seamless working environment. Discuss best practices to build this connected health ecosystem, one that helps to inform medical professionals, patients, and public health without compromising individual privacy.",
        "room": [
          {
            "id": 751,
            "name": "Meeting Room 9",
            "floor": "1",
            "number": "Meeting Room 9",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 581,
          "name": "Healthcare",
          "title": "Healthcare",
          "description": "N/A",
          "color": "#6EA204"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3136,
        "name": "Dell EMC For Data Protection: Key Ingredient In Modernization & Transformation",
        "abstract": "As critical business data get more and more distributed from core to edge to cloud, as new regulations surface (GDPR) and new threats to business operations arise such (i.e. Cyber-attacks)-data protection gains importance and priority as a critical pillar in the IT transformation journey. Come find out how Dell EMC’s Data protection portfolio can help you powerfully transform your data protection strategies with a thorough approach to data protection regardless of where your data lives, on-premise or in multiple clouds, or how you consume it. Also find out what’s new in the year with our protection appliances Data Domain, Integrated Data Protection Appliance’s(IDPA) and software with Data Protection Suite(DPS) to further simplify, automate and modernize your current data protection environment, providing the transformative data protection infrastructure to meet the future demands.",
        "room": [
          {
            "id": 743,
            "name": "Jr Ballroom - B1 & B2",
            "floor": "3",
            "number": "Jr Ballroom - B1 & B2",
            "capacity": "192"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [
          {
            "id": 2015,
            "name": "Steve Long",
            "email": "steve.long@Dell.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "Advisory Systems Engineer",
            "company": "Dell EMC, Data Protection"
          }
        ],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3137,
        "name": "Zero To Virtual Desktops In The Shortest Time Possible: Simplifying & Securing VDI Deployments With VMware-Powered Dell EMC Hyper-Converged Solutions",
        "abstract": "Leverage the power of end-to-end hyper-converged solutions to get your virtual desktop and application environment up and running quickly and securely. Join us to hear how customers around the world have benefited from technology from Dell and VMware to modernize, secure and futureproof their end user computing strategy.",
        "room": [
          {
            "id": 744,
            "name": "Jr Ballroom - C2",
            "floor": "3",
            "number": "Jr Ballroom - C2",
            "capacity": "96"
          }
        ],
        "track": {
          "id": 553,
          "name": "Workforce Transformation",
          "title": "Workforce Transformation",
          "description": "N/A",
          "color": "#00447C"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3138,
        "name": "Virtustream & Pivotal: Run Cloud-Native Mission-Critical Apps In Enterprise-Class Cloud",
        "abstract": "Your critical apps must change easily, resist failure, and be secure. This means running those applications on cloud-native platforms like Pivotal Cloud Foundry, with an enterprise-class cloud such as Virtustream Enterprise Cloud for the robustness you need. Attend this session to learn how Pivotal, Virtustream, VMware, and other Dell technologies combine to provide an enterprise-class cloud-native solution for mission-critical apps.",
        "room": [
          {
            "id": 745,
            "name": "Jr Ballroom - D2",
            "floor": "3",
            "number": "Jr Ballroom - D2",
            "capacity": "84"
          }
        ],
        "track": {
          "id": 551,
          "name": "Digital Transformation",
          "title": "Digital Transformation",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2043,
            "name": "Chandhubabu Thathineni",
            "email": "cthathineni@pivotal.io",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Virtustream/Pivotal"
          }
        ],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3140,
        "name": "Accelerate Workforce Transformation with VMware Workspace ONE and Dell",
        "abstract": "The way we work, how we work and where we work is changing at a dramatic pace. As you seek to leverage this tsunami of change within your organization, learn how VMware Workspace ONE and Dell are uniquely positioned to accelerate this transformation within your workforce by taking a modern management approach across any app, device, and use case. In this session, we’ll outline a prescriptive path for your IT to transition PC management workloads from traditional, siloed tools to a unified modern management of your Dell devices running Windows 10.",
        "room": [
          {
            "id": 747,
            "name": "Meeting Room 5",
            "floor": "1",
            "number": "Meeting Room 5",
            "capacity": "97"
          }
        ],
        "track": {
          "id": 553,
          "name": "Workforce Transformation",
          "title": "Workforce Transformation",
          "description": "N/A",
          "color": "#00447C"
        },
        "speaker": [
          {
            "id": 2044,
            "name": "Kevin Stromeyer",
            "email": "kstrohmeyer@vmware.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Vmware"
          }
        ],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3141,
        "name": "A Digital City is Data-Driven Special Guest:   Dennis John, CIO of City of Arlington",
        "abstract": "Explore how to develop a foundation to launch a Digital Community Initiative and learn about industry trends and case studies involving smart technology and data.",
        "room": [
          {
            "id": 750,
            "name": "Meeting Room 8",
            "floor": "1",
            "number": "Meeting Room 8",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 556,
          "name": "State and Local Government",
          "title": "State and Local Government ",
          "description": "N/A",
          "color": "#B7295A"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3142,
        "name": "Security Transformation in Healthcare",
        "abstract": "There is growing recognition in the healthcare ecosystem that the very digital infrastructure and connectedness that enables us to provide safer and efficient patient care also expands risk. In recognition of growing cyberthreats and breaches, understand strategies and tools available now to secure and protect patient and organizational data, whether in transit or at rest deploying a holistic, multi-layered tailored to the specific needs of healthcare providers and life sciences organizations.",
        "room": [
          {
            "id": 751,
            "name": "Meeting Room 9",
            "floor": "1",
            "number": "Meeting Room 9",
            "capacity": "105"
          }
        ],
        "track": {
          "id": 581,
          "name": "Healthcare",
          "title": "Healthcare",
          "description": "N/A",
          "color": "#6EA204"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3143,
        "name": "Conversation with the Executive Leadership Team",
        "abstract": "N/A",
        "room": [
          {
            "id": 752,
            "name": "Grand Ballroom",
            "floor": "4",
            "number": "Grand Ballroom",
            "capacity": "2000"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536870300000,
        "end_timestamp": 1536873300000
      },
      {
        "id": 3144,
        "name": "Cocktail",
        "abstract": "N/A",
        "room": [
          {
            "id": 754,
            "name": "Level 4 Prefunction",
            "floor": "4",
            "number": "Level 4 Prefunction",
            "capacity": "2184"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536873300000,
        "end_timestamp": 1536877800000
      },
      {
        "id": 3196,
        "name": "The Power of Modern: Dell EMC Storage & Data Protection Solutions",
        "abstract": "Modern IT begins with modern infrastructure.  Infrastructure that can drive applications, new and old, glean value from information, and protect what has rapidly become your most valued asset – your data.  Learn about the Dell EMC industry-leading Storage & Data Protection portfolio – what’s new, what’s cutting-edge, and what we can do to help your organization accelerate your business on your path to Digital Transformation",
        "room": [
          {
            "id": 742,
            "name": "Jr Ballroom - A1 & A2",
            "floor": "3",
            "number": "Jr Ballroom - A1 & A2",
            "capacity": "246"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [
          {
            "id": 2006,
            "name": "Kyle Leciejewski",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": ""
          }
        ],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3197,
        "name": "The Dell Advantage",
        "abstract": "As we look to streamline and digitally transform our businesses it’s hard to know who best to partner with and what advantages different vendor strategies bring to the table. In this fast moving world, automation, management, supply chain and support are more critical than ever but this must also be coupled to an outstanding product portfolio. In this session we explore the benefits of combining client solutions from Dell with enterprise solutions from Dell EMC to simplify and enhance your IT infrastructure, better meet your needs and streamline transformation journey.",
        "room": [
          {
            "id": 745,
            "name": "Jr Ballroom - D2",
            "floor": "3",
            "number": "Jr Ballroom - D2",
            "capacity": "84"
          }
        ],
        "track": {
          "id": 610,
          "name": "DellEMC",
          "title": "DellEMC",
          "description": "DellEMC",
          "color": "#007DB8"
        },
        "speaker": [
          {
            "id": 2040,
            "name": "Manuel Rodriguez",
            "email": "Manuel.Rodriguez-Perez@emc.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Dell EMC"
          }
        ],
        "contents": [],
        "start_timestamp": 1536864300000,
        "end_timestamp": 1536866400000
      },
      {
        "id": 3198,
        "name": "State of Cybercrime RSA & Secureworks",
        "abstract": "Take a tour of the Dark Web: Observations, Research, and Analysis from RSA and Secureworks. The cybercrime landscape continues to evolve at break-neck speed. With 3B+ consumer credentials stolen annually, cybercriminals have the advantage and look at new ways to execute upon them. Combined research from RSA and Secureworks explains the complexity of the online criminal landscape, market economies of online crime, and how cybercriminals hunt for potential points of compromise.",
        "room": [
          {
            "id": 742,
            "name": "Jr Ballroom - A1 & A2",
            "floor": "3",
            "number": "Jr Ballroom - A1 & A2",
            "capacity": "246"
          }
        ],
        "track": {
          "id": 561,
          "name": "RSA/Secureworks",
          "title": "RSA/Secureworks",
          "description": "N/A",
          "color": "###42AEAF"
        },
        "speaker": [
          {
            "id": 2042,
            "name": "Ayelet Biger-Levin",
            "email": "ayelet.biger@rsa.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "CISSP |Senior Consultant, Identity Product Marketing",
            "company": "Kristin Kelley - RSA/Secureworks"
          }
        ],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3201,
        "name": "Women in IT",
        "abstract": "N/A",
        "room": [
          {
            "id": 752,
            "name": "Grand Ballroom",
            "floor": "4",
            "number": "Grand Ballroom",
            "capacity": "2000"
          }
        ],
        "track": {
          "id": 609,
          "name": "General",
          "title": "General",
          "description": "N/A",
          "color": "#007DB8"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536865200000,
        "end_timestamp": 1536868800000
      },
      {
        "id": 3237,
        "name": "VMware NSX Architecture & Container Solution In The Dell EMC Ecosystem",
        "abstract": "VMware NSX is a key component of SDDC architecture and the bridge to a true hybrid cloud. This session will go over basic NSX functionality and explain its touch points with Dell EMC as well as showing new capabilities for containers.",
        "room": [
          {
            "id": 747,
            "name": "Meeting Room 5",
            "floor": "1",
            "number": "Meeting Room 5",
            "capacity": "97"
          }
        ],
        "track": {
          "id": 554,
          "name": "Security Transformation",
          "title": "Security Transformation",
          "description": "N/A",
          "color": "#CE1126"
        },
        "speaker": [
          {
            "id": 2030,
            "name": "Stijn Vanveerdeghem",
            "email": "svanveerdeghem@vmware.com",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "VMware"
          }
        ],
        "contents": [],
        "start_timestamp": 1536851700000,
        "end_timestamp": 1536854400000
      },
      {
        "id": 3238,
        "name": "Build your Connected Digital Campus with Cloud Integration",
        "abstract": "Higher Education Institutions are experiencing a transition from the way schools are offering services to their students, partners, and staff through digital innovation. There is a growing need to leverage new social, mobile, analytics and cloud (SMAC) technologies to deliver efficiencies rapidly while satisfying the high expectations of tech-savvy students wanting a rich and seamless experience across multiple channels.  In this session, learn how Dell Boomi can help manage the movement of data from legacy applications to hybrid architectures and how Cornell University has applied this technology to enhance its own ‘Digital Transformation’“",
        "room": [
          {
            "id": 749,
            "name": "Meeting Room 7",
            "floor": "1",
            "number": "Meeting Room 7",
            "capacity": "119"
          }
        ],
        "track": {
          "id": 555,
          "name": "Higher Education",
          "title": "Higher Education",
          "description": "N/A",
          "color": "#43E2FA"
        },
        "speaker": [],
        "contents": [],
        "start_timestamp": 1536867600000,
        "end_timestamp": 1536869700000
      },
      {
        "id": 3239,
        "name": "Customer Story",
        "abstract": "N/A",
        "room": [
          {
            "id": 743,
            "name": "Jr Ballroom - B1 & B2",
            "floor": "3",
            "number": "Jr Ballroom - B1 & B2",
            "capacity": "192"
          }
        ],
        "track": {
          "id": 550,
          "name": "IT Transformation",
          "title": "IT Transformation",
          "description": "N/A",
          "color": "#EE6411"
        },
        "speaker": [
          {
            "id": 2032,
            "name": "Top Golf/Amerisource Bergen Top Golf/Amerisource Bergen",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Regional Teams"
          }
        ],
        "contents": [],
        "start_timestamp": 1536855000000,
        "end_timestamp": 1536857100000
      },
      {
        "id": 3240,
        "name": "Customer Story",
        "abstract": "N/A",
        "room": [
          {
            "id": 746,
            "name": "Meeting Room 4",
            "floor": "1",
            "number": "Meeting Room 4",
            "capacity": "88"
          }
        ],
        "track": {
          "id": 553,
          "name": "Workforce Transformation",
          "title": "Workforce Transformation",
          "description": "N/A",
          "color": "#00447C"
        },
        "speaker": [
          {
            "id": 2037,
            "name": "Kendra Scott",
            "email": "",
            "photo": "https://app.highattendance.com/assets/img/user1.png",
            "title": "",
            "company": "Regional Teams"
          }
        ],
        "contents": [],
        "start_timestamp": 1536861600000,
        "end_timestamp": 1536863700000
      }
    ]
  }
  `;

  private data = JSON.parse(this.raw);

  constructor() { }

  get() {
    return this.data;
  }
}
